import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const ShutterFields = ({ value, onChange, testId }) => (
  <div className="rounded-lg border border-slate-200 bg-white p-3">
    <div className="flex items-center justify-between gap-3">
      <Label htmlFor={`${testId}-switch`} className="font-medium">Shutter</Label>
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <span>{value.has_shutter ? "Yes" : "No"}</span>
        <Switch id={`${testId}-switch`} checked={value.has_shutter} onCheckedChange={(v) => onChange({ has_shutter: v })} data-testid={`${testId}-switch`} />
      </div>
    </div>
    {value.has_shutter && (
      <Input value={value.shutter_details} onChange={(e) => onChange({ shutter_details: e.target.value })} maxLength={500}
        placeholder="Shutter details (optional), e.g. roller shutter, padlocked at base" className="mt-2" aria-label="Shutter details" data-testid={`${testId}-details`} />
    )}
  </div>
);

export const ShutterNote = ({ address, testId }) =>
  address.has_shutter ? (
    <p className="mt-3 rounded-lg border-l-4 border-amber-500 bg-amber-50 p-3 text-sm text-slate-800" data-testid={testId}>
      <span className="font-semibold">Shutter: Yes</span>{address.shutter_details ? ` · ${address.shutter_details}` : ""}
    </p>
  ) : null;
